import React from "react";
import TemplateItem from "./TemplateItem";

export default function TemplateGroup({ group, items, toggles, baseIdx, onToggle }) {
	return (
		<section>
			<h2 className="text-sm font-bold text-gray-700 mb-2">{group}</h2>
			<ul className="space-y-3">
				{items.map((item, iIdx) => (
					<TemplateItem key={item.name} name={item.name} desc={item.desc} checked={toggles[baseIdx + iIdx]} onToggle={() => onToggle(baseIdx + iIdx)} />
				))}
			</ul>
		</section>
	);
}
